<!--
client
child component
AT
13.02.21
-->

<svelte:window
	on:clientUpdated={getData}
/>

<script>

	//getting data from parent component
	export let data

	function getData(e){
//console.log('client:getData() e.detail: ',e.detail)
		data = e.detail || {}
	}

	function set(e){
		let
			client = window.$(e.target).siblings('input').first().val()

		window.Client.set( client )
	}

	function unset(){
		window.Client.unset()
	}

</script>

<div class="flex flex-middle">
	<div class="h-padded">
		Оформить на покупателя
	</div>
	<div class="h-padded">
		{ data.client.email || '' }
		{ #if data.client.firstname || data.client.lastname }
			<br>{ data.client.firstname } { data.client.lastname }
		{ /if }
		{ #if data.client.phone }
			<br>{ data.client.phone }
		{ /if }
		{ #if data.client.organization }
			<br>{ data.client.organization }
		{ /if }
	</div>
	<div class="flex flex-middle flex-nowrap">
		<input placeholder="email, тел., организация или ФИО"/>
		<button on:click={ set } class="spaced fit-input" >
			найти
		</button>
	</div>
	<div class="h-padded">
		{ data.message || '' }
	</div>
	{ #if Object.keys(data.client).length > 0 }
	<div class="h-padded">
		<a on:click={ unset } class="L">✕</a>
	</div>
	{ /if }
</div>